export default __webpack_public_path__ + "static/media/mic.c839502c.svg";